var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function submit($event) {
            $event.preventDefault()
            return _vm.onSearch.apply(null, arguments)
          },
        },
      },
      [
        _vm._t("filters"),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchTerm,
              expression: "searchTerm",
            },
          ],
          staticClass: "search-bar-input",
          attrs: {
            id: "search-bar-input-".concat(_vm.searchId),
            type: "text",
            "aria-label": _vm.$gettext(
              "Geben Sie einen Suchbegriff mit mindestens 3 Zeichen ein."
            ),
          },
          domProps: {
            value: _vm.searchTerm,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.searchTerm = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.showSearchResults
          ? _c(
              "button",
              {
                staticClass: "search-bar-erase",
                attrs: {
                  type: "button",
                  title: _vm.$gettext("Suchformular zurücksetzen"),
                },
                on: {
                  click: _vm.onReset,
                },
              },
              [
                _c("StudipIcon", {
                  attrs: {
                    shape: "decline",
                    size: 20,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "search-bar-filter",
            class: {
              active: _vm.showFilterPanel,
            },
            attrs: {
              type: "button",
              title: _vm.$gettext("Suchfilter einstellen"),
              "aria-controls": "search-bar-filter-panel-".concat(_vm.searchId),
              "aria-expanded": _vm.showFilterPanel ? "true" : "false",
            },
            on: {
              click: _vm.onToggleFilterPanel,
            },
          },
          [
            _c("StudipIcon", {
              attrs: {
                shape: "filter",
                role: _vm.showFilterPanel ? "info_alt" : "clickable",
                size: 20,
                alt: "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "submit-search",
            attrs: {
              type: "submit",
              value: _vm.$gettext("Suchen"),
              "aria-controls": "search-bar-input-".concat(_vm.searchId),
              title: _vm.$gettext("Suche starten"),
            },
          },
          [
            _c("StudipIcon", {
              attrs: {
                shape: "search",
                size: 20,
                role: "presentation",
                alt: "",
              },
            }),
          ],
          1
        ),
      ],
      2
    ),
    _vm._v(" "),
    _vm.showFilterPanel
      ? _c(
          "div",
          {
            ref: "filterPanel",
            staticClass: "filterpanel",
            attrs: {
              id: "search-bar-filter-panel-".concat(_vm.searchId),
            },
          },
          [_vm._t("default")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }